import React, {Component} from 'react';
import {CardNumberElement, CardExpiryElement, CardCVCElement, injectStripe} from 'react-stripe-elements';
import * as Components from './Components.js';
import API from './API.js';
import * as Helpers from './Helpers.js';

export function GetStripeKey(testAccount) {
  if (Helpers.isDevelopment() || testAccount) {
    return "pk_test_YGrmMLlzFzNJQ2YpqpIEAuKm"
  } else {
    return "pk_live_IdwrthZFwpJPjCax8qYw6uzc"
  }
}

class StripeElements extends Component {

  constructor(props) {
    super(props)

    let data = {}
    this.state = {
      data: data,
      forceCheck: false,
      error: undefined,
      shakeButton: false,
      loading: false
    }

    this.submitForm = this.submitForm.bind(this)
    this.formChanged = this.formChanged.bind(this)
    this.shakeTheButton = this.shakeTheButton.bind(this)
    this.submitStripeToken = this.submitStripeToken.bind(this)
  }

  /*
  * Submits the form
  */
  submitForm() {
    //1) Make sure every data element is valid.
    let valid = true
    for (let key in this.state.data) {
      if (this.state.data[key].valid === false) {
        valid = false
      }
    }
    //2) Make sure we have all of the data.
    let requiredFields = ["address", "city", "state", "zipcode", "name"]
    requiredFields.forEach((element) => {
      if (this.state.data[element] === undefined || this.state.data[element].value === undefined) {
        valid = false
      }
    })
    //3) If valid, submit, else force check the fields for display.
    if (valid) {
      let data = {}
      for (let key in this.state.data) {
        data[key] = this.state.data[key].value
      }
      //Submit the form
      this.submitStripeToken(data)
    } else {
      console.log("Form not valid to submit")
      this.setState({
        forceCheck: true
      })
      //Shake the submit button as it is invalid to submit
      this.shakeTheButton()
      return
    }
  }

  /*
  * Called when data in an input form changes.
  * This will update the state.data param with the
  * name and new value of the form element.
  */
  formChanged(name, value, valid) {
    this.setState((prevState) => {
      let d = prevState.data
      d[name] = {
        value: value,
        valid: valid
      }
      return {
        data: d
      }
    })
  }

  /*
  Shakes the button and then removes the class.
  */
  shakeTheButton() {
    this.setState({
      shakeButton: true
    }, () => {
      setTimeout(() => {
        this.setState({
          shakeButton: false
        })
      }, 1000)
    })
  }

  submitStripeToken(data) {
    //Make sure stripe is active
    if (this.props.stripe) {
      //Get the data from stripe and pass in the data from our forms
      this.setState({
        loading: true
      }, () => {
        this.props.stripe.createToken({
          name: data.name,
          address_line1: data.address,
          address_city: data.city,
          address_state: data.state,
          address_zip: data.zipcode,
          address_country: "US",
          currency: "usd",
        }).then((payload) => {
          if (payload.token) {
            console.log("saving card", payload.token.id)
            API.callDarwinAPI("PUT", "creditCardInfo", {
              tokenID: payload.token.id
            }, (result) => {
              if ("error" in result) {
                //3) On Error, show the error dialog
                this.setState({
                  loading: false
                }, () => {
                  this.props.showPopup("Error", "Couldn't save your credit card info", result.error)
                })
                return
              }
              console.log("Success")
              this.props.finished()
            })
          } else {
            console.log("Error creating token")
            this.setState({
              loading: false
            }, () => {
              this.props.showPopup("Error", "Couldn't validate your card", "Please try again.")
            })
          }
        });
      })
    } else {
      this.props.showPopup("Error", "Stripe not loaded", "Please reload the page and try again.")
    }
  }

  render() {

    let elementStyle = {
      base: {
        color: '#393C51',
        fontFamily: 'Montserrat, Helvetica, Arial, sans-serif',
        fontSize: '18px',
        fontWeight: '300',
        iconColor: '#8B4CFF',
        '::placeholder': {
          color: '#B3B1B5',
        },
      },
      complete: {
        color: '#8B4CFF',
        fontFamily: 'Montserrat, Helvetica, Arial, sans-serif',
        fontSize: '18px',
        fontWeight: '300',
      },
      empty: {
        color: '#B3B1B5',
        fontFamily: 'Montserrat, Helvetica, Arial, sans-serif',
        fontSize: '18px',
        fontWeight: '300',
      },
      invalid: {
        color: '#FF406C',
        fontFamily: 'Montserrat, Helvetica, Arial, sans-serif',
        fontSize: '18px',
        fontWeight: '300',
      }
    }

    return (
      <div className="StripeCheckout">
        { this.state.loading &&
          <div className="StripeCheckoutLoading">
            <div>
              <Components.LoadingIndicator top="60px" />
            </div>
          </div>
        }
        <div className={"StripeCheckoutContainer"}>

          { (this.props.userInfo.testAccount === "1" || Helpers.isDevelopment()) &&
            <div className="TestLabel">
              Stripe Test Mode
            </div>
          }
          <div className="StripeCheckoutInsideContainer">
            <div className="InputSection">
              Billing Address
            </div>
            <div className="InputDiv">
              <Components.InputBottomLine type="text" name="address" placeholder="address" validation="text" required="true" maximum={255}
                title="Address"
                value={this.state.data.address ? this.state.data.address.value : ""} onEnter={this.submitForm} onChange={this.formChanged} forceCheck={this.state.forceCheck} />
            </div>
            <div className="InputDiv">
              <Components.InputBottomLine type="text" name="city" placeholder="city" validation="text" required="true" maximum={255}
                title="City"
                value={this.state.data.city ? this.state.data.city.value : ""} onEnter={this.submitForm} onChange={this.formChanged} forceCheck={this.state.forceCheck} />
            </div>
            <div className="InputDiv">
              <Components.InputBottomLine type="text" name="state" placeholder="state" validation="text" required="true" maximum={255}
                title="State"
                value={this.state.data.state ? this.state.data.state.value : ""} onEnter={this.submitForm} onChange={this.formChanged} forceCheck={this.state.forceCheck} />
            </div>
            <div className="InputDiv">
              <Components.InputBottomLine type="text" name="zipcode" placeholder="zipcode" validation="text" required="true" maximum={255}
                title="Zip Code"
                value={this.state.data.zipcode ? this.state.data.zipcode.value : ""} onEnter={this.submitForm} onChange={this.formChanged} forceCheck={this.state.forceCheck} />
            </div>
          </div>

          <div className="InputSectionLine"></div>
          <div className="StripeCheckoutInsideContainer" style={{marginBottom:"20px"}}>
            <div className="InputSection">
              Credit Card
            </div>
            <div className="InputDiv">
              <Components.InputBottomLine type="text" name="name" placeholder="name" validation="text" required="true" maximum={255}
                title="Name"
                value={this.state.data.name ? this.state.data.name.value : ""} onEnter={this.submitForm} onChange={this.formChanged} forceCheck={this.state.forceCheck} />
            </div>
            <div className="inputBottomLineLightContainer">
              <div className="inputBottomLineTitle">
                Credit Card Number
              </div>
              <CardNumberElement style={elementStyle} />
            </div>
            <div className="inputBottomLineLightContainer">
              <div className="inputBottomLineTitle">
                Expiration Date
              </div>
              <CardExpiryElement style={elementStyle} />
            </div>
            <div className="inputBottomLineLightContainer">
              <div className="inputBottomLineTitle">
                CVC Number
              </div>
              <div className="inputBottomLineDescription">
                The 3 or 4 digit number on the back of your card
              </div>
              <CardCVCElement style={elementStyle} />
            </div>

            <div className="ButtonDiv">
              <Components.MaterialButton type="Purple" size="Large" onClick={this.submitForm} shake={this.state.shakeButton}>Save Card</Components.MaterialButton>
            </div>
            { !this.props.mandatory &&
              <div className="ButtonDiv">
                <Components.MaterialButton type="TextDark" size="Large" onClick={this.props.finished}>Cancel</Components.MaterialButton>
              </div>
            }
            <div className="ButtonDiv">
              <Components.MaterialButton type="TextDark" onClick={API.logout}>Logout</Components.MaterialButton>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export const StripeForm = injectStripe(StripeElements);
